<template>
	<div id="app">
		<!-- Header -->
		<header id="home" class="header-area">
			<CommonHeader />
			<ClientMenu v-show="isLoggedIn && !forcePasswordChange" />
		</header>
		<router-view/>
		<CommonFooter />
		<div class="bg-danger w-100"  style="position: fixed; top: 0; left: 0; z-index: 1000; min-height: 100vh; display: flex; align-items: center; opacity: 0.7" v-if="connectionLost">
			<h1 class="text-center align-middle w-100 text-white">NETWORK CONNECTION LOST</h1>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { timer } from "vue-timers";
import JwtDecode from 'jwt-decode';
import moment from 'moment';
import i18n from '@/i18n';

import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { errHandler, errMessage } from "@/lib/handlers";
import { mapDebugActions, DEBUG } from '@/lib/debug.js';

export default {
	name: "App",
	components: {
		CommonHeader: () => import('@/components/common/Header.vue'),
		ClientMenu:   () => import('@/components/ClientMenu.vue'),
		CommonFooter: () => import('@/components/common/Footer.vue')
	},
	data() {
		return {
			initializedApp: false,
			connectionLost: false
		};
	},
	computed: {
		...mapGetters(["apiToken", "isLoggedIn", "currentUserId", "inboxUnread"]),
		forcePasswordChange() {
			return (this.$store.state.auth.user.password_changed_at == null) ? true : false
		}
	},
	beforeDestroy() {
		this.debugMessage('Unloading Event Listeners');

		// Deregister Event Listeners
		//EventBus.$off('notification-event', this.onNotificationEvent);
		EventBus.$off('login-event', this.onLoginEvent);
		EventBus.$off('logout-event', this.onLogoutEvent);
		EventBus.$off('heartbeat-event', this.onHeartbeatEvent);
		EventBus.$off('heartbeat-event', this.onHeartbeatEventRefreshToken);
		EventBus.$off('heartbeat-event', this.onHeartbeatEventGetMessages);
		EventBus.$off('network-error-event', this.onNetworkErrorEvent);
	},
	created() {
		if (this.forcePasswordChange) this.profileRedirect
	},
	mounted () {
		this.debugMessage('Loading Event Listeners');
		// this.checkCurrentLogin(); // Not needed, UPDATED() runs right after created and mounted
		EventBus.$on('login-event', this.onLoginEvent);
		EventBus.$on('logout-event', this.onLogoutEvent);
		EventBus.$on('heartbeat-event', this.onHeartbeatEvent);
		EventBus.$on('heartbeat-event',	this.onHeartbeatEventRefreshToken);
		EventBus.$on('heartbeat-event', this.onHeartbeatEventGetMessages);
		EventBus.$on('network-error-event', this.onNetworkErrorEvent);
	},
	updated() {

		// If locale is passed, Set Locale
		if (this.$route.query && this.$route.query.lang) {
			if ( i18n.availableLocales.indexOf(this.$route.query.lang) >= 0) i18n.locale = this.$route.query.lang;
		}

		this.checkCurrentLogin();
	},
	timers: {
		heartBeatTimer: { time: 90000, autostart: true, repeat: true }
	},
	methods: {
		...mapActions(["refreshToken", "fetchFolders", "currentUser", "fetchLocale", "logout"]),
		...mapNotificationEventActions,
		...mapDebugActions,
		checkCurrentLogin () {

			let redirect = (this.$route.query.redirect) ? this.$route.query.redirect : null;
			this.onLoginEvent(redirect);

			if (this.$route.name == "login") {
				if (this.isLoggedIn) this.$router.push("/");
			} else if (this.$route.meta.noLoginRequired == true) {
				////
				// Fall through for routes that don't require login
				////
			} else {
				if (!this.isLoggedIn && this.$route.name != null) {
					this.initializedApp = false;
					if (this.$route.path != '/') this.$router.push("/login?redirect=" + this.$route.path);
					else this.$router.push('/login');
				}
			}
		},
		heartBeatTimer () {
			EventBus.$emit('heartbeat-event', {});
		},
		onHeartbeatEventRefreshToken () {
			let token = this.apiToken;
			if (!!token) {
				const { exp } = JwtDecode(token);

				//just for testing - need to be removed
				if (!(exp > moment().unix())){console.log("custom code - ab721 value set to ", exp > moment().unix())}

				if ( exp > moment().unix() ) {
					this.refreshToken().then( (v) => { this.connectionLost = !v; }).catch( errHandler );
					return;
				}
			}
			this.logout();
			this.connectionLost = false;
		},
		onHeartbeatEvent () {
			this.debugMessage('heartbeat-event received >> **ba-bump**');
		},
		onHeartbeatEventGetMessages () {
			if (this.isLoggedIn && !this.disableChatter()) this.fetchFolders();
		},
		onNetworkErrorEvent () {
			if (this.isLoggedIn) this.connectionLost = true;
		},
		onLogoutEvent () {
			if (this.isLoggedIn) {
				this.debugMessage ('Logout Event');
				this.logout();
			}
		},
		onLoginEvent (redirect) {

			if (this.isLoggedIn && !this.initializedApp) {

				this.debugMessage('login-event received, initializing OTU object');

				this.initializedApp = true;

				this.currentUser().then((v) => {
					if (this.forcePasswordChange)
						this.$router.push( {path: `/profile/#password`} )
				});
				this.fetchFolders();
				this.fetchLocale();

				if (redirect) this.$router.push(redirect);

			}
		},
		profileRedirect() {
			this.$router.push( {path: `/profile/#password`} )
		}
	}
}
</script>
